export function docus_checklist_eval(id, val) {
    if (val=='' || val==undefined) {
        $('#'+id+'_caption').parent().parent().addClass('checklist_warning');
        $('#'+id+'_caption').parent().parent().removeClass('checklist_ok');
        $('#'+id+'_caption').addClass('checklist_warning');
        $('#'+id+'_caption').removeClass('checklist_ok');
    } else {
        $('#'+id+'_caption').parent().parent().addClass('checklist_ok');
        $('#'+id+'_caption').parent().parent().removeClass('checklist_warning');
        $('#'+id+'_caption').addClass('checklist_ok');
        $('#'+id+'_caption').removeClass('checklist_warning');
    }
}


export function count_docu_checkboxes_checked(docus_class) {
    // returns count of checked checkboxes of class 'docu_class'
    //
    var max_checked=0;
    $("."+docus_class).each(function() {
        if ($(this).is(":checked")) { max_checked+=1;}
    });
    return max_checked;
}

export function count_docu_checkboxes_checked_except_none(docus_class, id_none) {
    // returns count of checked checkboxes of class 'docu_class' except the one with id of 'none' option
    var max_checked=0;
    $("."+docus_class).not('#'+id_none).each(function() {
        if ($(this).is(":checked")) { max_checked+=1;}
    });
    return max_checked;
}



export function get_checkboxes_results(id_base, field_prefix) {
    // get_checkboxes_results('docus_bam', 'fs');
    // DEBUG_OK 220110
    var checkboxes_class = id_base + '_' + field_prefix + '_option';
    var result_field = id_base + '_' + field_prefix + '_result';
    var count_checked = count_docu_checkboxes_checked(checkboxes_class);
    if (count_checked===0) {
        $('#'+result_field).val('');
    } else {
        $('#'+result_field).val(count_checked);
    }
    evaluate_mandatory_fields(id_base);
}



export function cancel_all_docus_options_for_none(id_none, id_prefix, docus_class) {
    // called by event handler for option 'none' (keine, keiner) from a list of checkboxes
    // if id_none ist set, all other options from class 'docus_class' will bei disabled
    // includes updating css of the corresponding label
    if ($('#'+id_none).is(":checked")) {
        $('.'+docus_class).not('#'+id_none).prop('checked', false);
        $("span[id^='"+id_prefix+"']").not('#'+id_none+'_label').removeClass('checked');
    }
}

export function cancel_docus_none_option(id_none) {
    $('#'+id_none).prop('checked', false);
    $('#'+id_none+'_label').removeClass('checked');
}



export function evaluate_mandatory_fields(id_prefix) {
    // id_prefix: e.g. 'docus_bam'
    // check all VISIBLE input elements starting with 'id_prefix' for 'data-mandatory' attribute beeing 'true'
    // evaluate their value
    // if empty, set corresponding '_label' element class to 'warning'
    // called by item_trigger_functions.js/item_mandatory_handler AND check_for_mandatory_docus_field,

    // DEBUG INFO:  [data-mandatory='true']:visible  ignores hidden input fields - as used fro checkbox-array result-field
    var missing_labels = '';
    $("[id^='"+id_prefix+"_phase']:visible [data-mandatory='true'], [id^='"+id_prefix+"_section']:visible [data-mandatory='true']").each(function() {
        //console.log($(this).attr('id')+',  field_val: '+window[$(this).attr('id')+'_get_field_val']());

        var field_val = window[$(this).attr('id') + '_get_field_val']();
        var label_of_missing_field = $('#' + $(this).attr('id') + '_label');

        if (field_val=='' || field_val==false) {
            label_of_missing_field.addClass('warning');
            if (missing_labels != '') missing_labels += ', '
            missing_labels += label_of_missing_field.html().replace('*', '').trim();
        } else {
            label_of_missing_field.removeClass('warning');
        }
    });

    if ($('#'+id_prefix+'_mandatory_missings')) {
        $('#'+id_prefix+'_mandatory_missings').val(missing_labels);
        $('#'+id_prefix+'_mandatory_missings_text').text(missing_labels);
        $('#'+id_prefix+'_mandatory_missings').trigger('change');
    }

}